module.exports = __webpack_public_path__ + "img/login-image.3557f392.png";